import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { SectionModelType } from '../types/section.type';
import { durationToSeconds } from './duration.utils';

/**
 * Les intervalles doivent couvrir exactement `getTargetSeconds()` (la duree de la video en coaching),
 * a la seconde pres. Sans duree cible ou sans intervalle, rien a comparer : `Validators.required`
 * s'occupe du second cas.
 *
 * Erreurs : `sectionsTooShort.missing` / `sectionsTooLong.excess`, en secondes.
 */
export function sectionsDurationValidator(getTargetSeconds: () => number | undefined): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const target: number | undefined = getTargetSeconds();
    const sections: SectionModelType[] | null = control.value;
    if (!target || !sections?.length) return null;
    const total: number = sections.reduce(
      (sum: number, section: SectionModelType) => sum + durationToSeconds(section.duration),
      0,
    );
    const gap: number = total - Math.round(target);
    if (gap < 0) return { sectionsTooShort: { missing: -gap } };
    if (gap > 0) return { sectionsTooLong: { excess: gap } };
    return null;
  };
}
